import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _excluded = ["value", "options", "mode", "placeholder", "defaultValue", "size", "onChange", "optionLabelProp"];

var _templateObject;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { Select } from 'antd';
import styled from '@xstyled/styled-components';
import { styleVariables } from '../../../style';
import { jsx as _jsx } from "react/jsx-runtime";
var Option = Select.Option;
var StyledSelect = styled(Select)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  border-radius: 2px;\n  width: 100%;\n  .ant-select:not(.ant-select-customize-input) .ant-select-selector {\n    background: red !important;\n  }\n  &:not(.ant-select-disabled):hover,\n  &:not(.ant-select-disabled):active {\n    .ant-select-selector {\n      border-color: ", " !important;\n    }\n  }\n  .ant-select-selector {\n    height: 42px !important;\n    display: flex;\n    align-items: center;\n  }\n"])), styleVariables.colors.blue4);
export var RootSelectInput = function RootSelectInput(props) {
  var value = props.value,
      options = props.options,
      mode = props.mode,
      placeholder = props.placeholder,
      defaultValue = props.defaultValue,
      size = props.size,
      onChange = props.onChange,
      optionLabelProp = props.optionLabelProp,
      rest = _objectWithoutProperties(props, _excluded);

  return /*#__PURE__*/_jsx(StyledSelect, _objectSpread(_objectSpread({
    value: value,
    mode: mode,
    placeholder: placeholder,
    defaultValue: defaultValue,
    onChange: onChange,
    size: size,
    optionLabelProp: optionLabelProp
  }, rest), {}, {
    children: options.map(function (option, index) {
      var value = option.value,
          label = option.label;
      return /*#__PURE__*/_jsx(Option, {
        value: value,
        children: label
      }, index);
    })
  }));
};